
<div #chatContainer *ngFor="let item of content, let i = index" 
    class="{{item.type == 'you'?'flex justify-end':''}}
.run-animation ">

    <ng-container *ngIf="item.content"
        class="bg-[#5BACAD33] gap-[1rem] rounded-full rounded-br-none my-2 px-8 min-h-[1rem]">
        <app-card-chat 
            [onResendQ]="onResendQ"
            [content]="content" [index]="i" [ogText]="item.content" [type]="item.type" 
            [text]="item.type == 'you' ? item.content : item.type == 'module-list'? '': null"
            [prompts]="item?.prompts?.length > 0 ? item.prompts : item?.suggestions?.length > 0?item.suggestions:null"
            [iconRightUrl]="item.type == 'you' ? item.perfil : ''" 
            [CardChatData]="{cardClass: item.type == 'you' ? 'you-background rounded-tr-none' : 'bg-[#F2F2F2] w-[70%]'}">
            <ng-container *ngIf="item.type == 'text'">
                <app-text *ngIf="item.type == 'text'" 
                    [content]="item.content.text?[item.content.text]:item.content"
                    [typed]="item.typed" 
                />

                <div *ngIf="item.actions && item.actions.length>0">
                    <p class="mt-5 mb-5">
                        <span class="cursor-pointer p-2 bg-[#00527E] rounded-xl font-bold text-white m-2"
                            (click)="executeAction(item, action)"
                            *ngFor="let action of item.actions">
                            {{action.label}}
                        </span>
                    </p>
                </div>
            </ng-container>

            <ng-container *ngIf="item.AnswerContext && item.AnswerContext=='GRAPH' && item.object_"> 
                <!--
                <div>
                    <p>Encontrei {{ item.object_.length }} objectos.</p>
                </div>
                -->
                <div class="grid grid-cols-3">
                    <div class="grid-col" *ngFor="let object of item.object_">
                        <div class="mr-5 mb-5" >                        
                            <div style="height: 200px;background:#f4f4f4;background-image:url('{{object.url}}');background-size:contain;">
                            </div>
                            <div style="padding:5px;border:1px inset #ccc;border-top: 0px;box-shadow:0px 0px 2px rgba(0,0,0.3);">
                                <p>{{ object.label }}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-container>

            <ng-container *ngIf="item.type == 'html'"> 
                <div [innerHTML]="item.content.text"></div>
            </ng-container>

            <ng-container *ngIf="item.report!=null && item.report!=undefined"> 
                <app-fatura-details [report]="item.report"></app-fatura-details>
            </ng-container>
            
            <!-- Formulário a ser exibido apenas se for 'XML Report' -->
            <ng-container *ngIf="item.xml_report">
                <app-form [xmlReport]="item.xml_report"></app-form>
            </ng-container>
        </app-card-chat>
    </ng-container>
</div>


<div *ngIf="isChatLoading()" class="flex items-center rounded-xl rounded-tl-none p-[1rem] w-[7rem] ">
    <app-rounded-icon-buttom [buttonData]="{iconUrl:'assets/img/quadro.svg',btnClass:'w-[3rem] h-[3rem] '}" />
    <div role="status">
        <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
            <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
        </svg>
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div *ngIf="!widget" class="h-[30vh]"></div>